import { Component } from '@angular/core';
import { TwoWayBoundComponent } from '@app/shared/components/base/two-way-bound.component';
import { Contact } from '@app/shared/models/contact';

@Component({
    selector: 'contacts-twb',
    templateUrl: './contacts.component.html',
    styleUrls: ['./contacts.component.scss']
})
export class ContactsComponent extends TwoWayBoundComponent<Contact[]> {

    get contacts(): Contact[] {
        return this.bananaBox;
    }

    constructor() {
        super();
        this._idPrefix = 'contacts.';
    }

    public addContact(): void {
        this.contacts.push(new Contact({ name: '', value: '' }));
    }

    public removeContact(idx: number): void {
        this.contacts.splice(idx, 1);
        this.onChange();
    }
}
